export default __webpack_public_path__ + "static/kokall-zomer-1-b3499a48e967f66a04c93c69945a3335.png";